var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AnnotationType } from "@@/Annotation";
import { testIsMobile } from "@@/Util";
import { action, makeObservable, observable } from "mobx";
export class CodeEditorState {
    constructor() {
        this.topposition = 30;
        this.leftposition = 200;
        this.width = testIsMobile() ? 300 : 750;
        this.height = testIsMobile() ? 200 : 550;
        this.dragging = false;
        this.show = false;
        this.text = "";
        this.selectedid = "";
        this.selectesid = "";
        this.selectecid = "";
        this.selectechid = "";
        this.choicitems = [];
        this.editmode = false;
        this.readonly = false;
        this.annotationtype = undefined;
        this.showextra = false;
        this.thickness = 3;
        this.strokewidth = 3;
        this.onok = () => { };
        makeObservable(this);
    }
    setThickness(th) {
        this.thickness = th;
    }
    setSWidth(th) {
        this.strokewidth = th;
    }
    setShowExtraOptions(show) {
        this.showextra = show;
    }
    setDatasheetId(id) {
        if (this.selectedid === id)
            return;
        this.selectedid = id;
        this.selectecid = "";
        this.selectesid = "";
        this.selectechid = "";
    }
    setSchemaId(id) {
        if (this.selectesid === id)
            return;
        this.selectecid = "";
        this.selectechid = "";
        this.selectesid = id;
    }
    setColumnId(id) {
        this.selectecid = id;
        this.selectechid = "";
    }
    setColumnChoiceId(id) {
        this.selectechid = id;
    }
    setActiveAnnotationType(type) {
        this.annotationtype = type;
    }
    setReadonly(readonly) {
        this.readonly = readonly;
    }
    setContent(content) {
        this.text = content;
    }
    setEditMode(edit) {
        this.editmode = edit;
    }
    setShow(show) {
        this.show = show;
    }
    setDragging(drag) {
        this.dragging = drag;
    }
    setToppos(pos) {
        this.topposition = pos;
    }
    setLeftPos(pos) {
        this.leftposition = pos;
    }
    reset() {
        this.showextra = false;
        this.text = "";
        this.setDatasheetId("");
        this.choicitems.splice(0, this.choicitems.length);
    }
    addChoiceItems(cit) {
        this.choicitems.splice(0, this.choicitems.length);
        this.choicitems.push(...cit);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], CodeEditorState.prototype, "topposition", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], CodeEditorState.prototype, "leftposition", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], CodeEditorState.prototype, "width", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], CodeEditorState.prototype, "height", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], CodeEditorState.prototype, "dragging", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], CodeEditorState.prototype, "show", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], CodeEditorState.prototype, "text", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], CodeEditorState.prototype, "selectedid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], CodeEditorState.prototype, "selectesid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], CodeEditorState.prototype, "selectecid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], CodeEditorState.prototype, "selectechid", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], CodeEditorState.prototype, "choicitems", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], CodeEditorState.prototype, "editmode", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], CodeEditorState.prototype, "readonly", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], CodeEditorState.prototype, "annotationtype", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], CodeEditorState.prototype, "showextra", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], CodeEditorState.prototype, "thickness", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], CodeEditorState.prototype, "strokewidth", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], CodeEditorState.prototype, "setThickness", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], CodeEditorState.prototype, "setSWidth", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], CodeEditorState.prototype, "setShowExtraOptions", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], CodeEditorState.prototype, "setDatasheetId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], CodeEditorState.prototype, "setSchemaId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], CodeEditorState.prototype, "setColumnId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], CodeEditorState.prototype, "setColumnChoiceId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], CodeEditorState.prototype, "setActiveAnnotationType", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], CodeEditorState.prototype, "setReadonly", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], CodeEditorState.prototype, "setContent", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], CodeEditorState.prototype, "setEditMode", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], CodeEditorState.prototype, "setShow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], CodeEditorState.prototype, "setDragging", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], CodeEditorState.prototype, "setToppos", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], CodeEditorState.prototype, "setLeftPos", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CodeEditorState.prototype, "reset", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], CodeEditorState.prototype, "addChoiceItems", null);
